import { apiFetch } from './base';

export type BotId = string;
export type ConversationId = string;

export async function getSessionToken(botId: BotId) {
  return apiFetch(`bots/${botId}/tokens`, 'POST');
}
